import React, { useMemo } from 'react';

import classNames from 'classnames';

import '@consumer-bootstrap/components/svg-icon.scss';
import '@consumer-bootstrap/index.scss';

export type SvgIconPropsPublicT = {
  className?: string;
  size?: string;
  style?: React.CSSProperties;
};

export type SvgIconPropsT = {
  Svg: React.FunctionComponent<React.ComponentProps<'svg'>>;
  className?: string;
  rotation?: number;
  size?: string;
  style?: React.CSSProperties;
};

export const SvgIcon: React.FC<SvgIconPropsT> = ({
  Svg,
  className,
  rotation = 0,
  size = '1rem',
  style,
}) => {
  const classes = classNames([className, 'svg-icon']);

  const styles = useMemo(() => {
    return {
      ...style, '--svg-icon-rotation': `${rotation}deg`, '--svg-icon-size': size,
    };
  }, [
    rotation,
    size,
    style,
  ]);

  return <span aria-hidden className={classes} style={styles}><Svg width="1em" height="1em" /></span>;
};
